import { Directive, HostBinding } from '@angular/core';
import { IWizRoute, WizBaseView, WizCommand, WizGroupCommand, WizNavigationManager, WizRoot, WizEventManager } from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE } from '../../model/enums';
import { Model } from '../../model/model';
import { PermissionVisibility, ViewPermission, PermissionAccess } from '../../manager/permission/permissions.types';
import { CtxtEntry } from '../../manager/context/user-context.service';

/** view base class */
@Directive()
export class BaseView extends WizBaseView {
  @HostBinding('class') baseStyle: string = 'base-view'; // style de base pour les vues

  public model: Model;

  /** les composants ne sont pas encore prêts. On va mémoriser leur appels pour éviter les doublons */
  public componentsArentReady: boolean = true;

  // déclenchée sur fin de constructeur
  wizAfterConstruct(): void {
    
    // alimentation du code de la vue et de son titre par déduction de la route (si existe)
    const route: IWizRoute = WizNavigationManager.getViewRoute(this);

    //  prise du modèle, on l'a injecté dans le routeur dans appModule
    this.model = WizNavigationManager.router['model'];

    if (route) {
      this.code = route.path;
      this.title = route.label;
    }

    super.wizAfterConstruct(); // va alimenter la déclaration de navig.. Donc joué APRES le feed
  }

  wizBeforeInit(): boolean | Promise<any>[] | WizGroupCommand | WizCommand<any> {
    super.wizBeforeInit();
    return true;
  }

  /**
   * @Override
   */
  wizInitComponents(): void {
    // signaler que la vue est opérationnelle, pour que les widgets puissent déclencher leurs cycles
    super.wizInitComponents(); //
    // les composants ont enregistré leurs appels dans pendingCalls. On peux lancer
    this.componentsArentReady = false;
  }

  private _hasUserLoadedEvent: boolean = false;

  wizAddListener() {
    if (!this.model.connectedUser) {
      WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.USER_LOADED, this.manageContext);
      this._hasUserLoadedEvent = true;
    }
  }

  wizRemoveListener() {
    if (this._hasUserLoadedEvent) {
      this._hasUserLoadedEvent = false;
      WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.USER_LOADED);
    }

  }

  /** ########### Panneaux latéraux & contexte ########### */

  /**
   * application du contexte de la vue (ex: ouverture des panneaux latéraux )
   */
  public manageContext(): void {
    if (!!this.model.connectedUser) {
      const currentTabContext: CtxtEntry = this.model.userContextService.getCurrentTab();
      if (currentTabContext?.showLeftPanel) {
        this.model.navigationEngine.showLeftSidePanel();
      }
      if (currentTabContext?.showRightPanel) {
        this.model.navigationEngine.showRightSidePanel();
      }
    }
  }

  /** classFactory pour le sideContainer de gauche (une classe) */
  public leftSideContent(): any {
    return null;
  }

  /** classFactory pour le sideContainer de droite (une classe) */
  public rightSideContent(): any {
    return null;
  }

  /**
   * demande de création d'un nouvel item, utile pour les navigations dynamiques
   */
  public askForAddFromContext(): void { }

  private _permissions: ViewPermission[];

  /**
   * Gestion des permissions sur les éléments de vue
   * @param elements
   */
  protected managePermissions(permissions: ViewPermission[]) {
    this._permissions = permissions;

    this._permissions.forEach((p) => {
      const accesses: PermissionAccess[] = this.model.permissionEngine.getFeatureAccesses(p.feature);
      const isReadOnly: boolean = !!accesses && accesses.length === 1 && accesses[0] === PermissionAccess.READ;
      p.permissions.forEach((cp) => {
        if (isReadOnly) {
          cp.component.wizDisabled = true;
        } else if (!this.hasAccess(accesses, cp.accesses)) {
          if (cp.visibility === PermissionVisibility.DISABLED) {
            cp.component.wizDisabled = true;
          } else if (cp.visibility === PermissionVisibility.HIDE) {
            cp.component.visible = false;
          }
        } else {
          cp.component.visible = true;
          cp.component.wizDisabled = false;
        }
      });
    });
  }

  private hasAccess(allowedAccesses: PermissionAccess[], askedAccesses: PermissionAccess[]): boolean {
    const setA = new Set(allowedAccesses);
    const setB = new Set(askedAccesses);
    const intersection = new Set(Array.from(setA).filter((x) => setB.has(x)));
    return Array.from(intersection).length > 0;
  }
}


